import { legends } from '../../dashboard/utils/legends';

export const getStatusColor = (status: string | null) => {
  return legends.find((element) => status === element.name)?.nodeColor ?? '#c0c0c0';
};

export const getTierColor = (tier: number | null) => {
  return tier === 3 ? '#c0c0c0' : 'black';
};
